import generalStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import 'photoswipe/dist/photoswipe.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import StatusBar from "../StatusBar";
import Step1 from "../Step1";
import Step2 from "../Step2";
import Step3 from "../Step3";
import StepNav from "../StepNav";
import {useAppData} from "../../context/Contexts";
import {getImageUrl} from '../../helpers/helpers';
import {useForm, useFormState} from 'react-hook-form'
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import {useQuery} from "@tanstack/react-query";
import {queryClient} from "../ProductService";
import useMediaQuery from '../../hooks/useMediaQuery'
import fetchCheck from '../../services/CheckService';
import useCustomProductQuery from "../../services/CustomProductService";
import {Gallery, Item} from 'react-photoswipe-gallery';
import BonusSection from "../BonusSection";
import Bonus3Section from '../Bonus3Section';
import Bonus3TitleSection from "../Bonus3Section/Bonus3TitleSection";
import RawHtml from "../RawHtml";
import Countdown from '../Countdown';
import MainStep from "../MainStep";
import StepNoCompatible from "../StepNoCompatible";




const Product: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [product, setProduct] = useState({});
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);

    const [oldSlide, setOldSlide] = useState(0);
    const [activeSlide, setActiveSlide] = useState(0);
    const [activeSlide2, setActiveSlide2] = useState(0);


    useEffect(() => {
        setNav1(sliderRef1);
        setNav2(sliderRef2);
    }, []);

    const {
        status,
        data,
        error,
        isFetching,
        refetch
    } = useQuery({
            queryKey: ['product'],
            queryFn: ({}) => fetchProduct(),
        }
    )

    const [filterSortOrder, setFilterSortOrder] = useStateWithCallbackLazy(['title', 'ascending']);

    const [queryAfter, setQueryAfter] = useState(null);

    const isMobile = useMediaQuery(768);
    const isTablet = useMediaQuery(1024);

    let Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || 'US';
    // console.log(`country: ${Shopify.country}`);

    const defaultQuery = (opts) => {
        let q = `
      query @inContext(country: ${Shopify.country}) {
        
  product(id: "gid://shopify/Product/${window.scs_product_id}") {
    id
    title
    handle
    availableForSale
    createdAt
    productType
    tags
    collections(first: 5) {
      edges {
        node {
          id
          title
        }
      }
    }
    images(first: 100) {
      edges {
        node {
          id
          url
          altText
        }
      }
    }
    options {
        id
        name
        optionValues {
            name
            id
        }
    }
    variants(first: 100) {
      edges {
        node {
          id
          sku
          availableForSale
          title
          currentlyNotInStock
          selectedOptions {
            name
            value
          }
          image {
            id
            url
          }
          priceV2 {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          
        }
      }
    }
  }
}`;

        return q;
    }

    const getSortKey = () => {

        switch (filterSortOrder[0]) {
            case 'title':
                return 'TITLE';
            case 'price':
                return 'PRICE';
            case 'created_at':
                return 'CREATED_AT';
            default:
                return 'TITLE';
        }
    }

    const buildQuery = (opts) => {
        const sortKey = getSortKey();

        let q = defaultQuery({sortKey, ...opts})

        // console.log(opts)
        // console.debug(q)

        return q;
    }

    const fetchProduct = async (pageParam = null) => {
        //console.log(key);
        // console.log('pageParam: ');
        // console.log(pageParam);

        const myHeaders = new Headers();
        myHeaders.append("X-Shopify-Storefront-Access-Token", "2ec833273cdc3f57cd90d9b80c9c5a80");
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
            query: buildQuery({}),
            variables: {"after": ""}
        })
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow'
        };

        const response = await fetch("https://seatcoversolutions-7977.myshopify.com/api/2024-07/graphql.json", requestOptions)
            .catch(error => console.log('error', error));

        const data = await response?.json();

        const prod = data.data.product;

        const first_variant = prod.variants.edges[0];

        const id = first_variant?.node?.id?.replace('gid://shopify/ProductVariant/', '');

        console.log('selectedId', id)

        setCurrentAppData(prevState => {
            return {...prevState, product: prod, originalProduct: prod, selectedId: id}
        });

        return data.data.product
    }

    const {control, reset, register, handleSubmit, getValues, formState} = useForm({
        reValidateMode: 'onBlur',

    });

    const thumbSettings = {
        centerMode: false,
        slidesToShow: 5,
        vertical: window.innerWidth >= 767,
        verticalSwiping: true,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        focusOnSelect: true,
        className: 'slider-nav-thumbnails',
        asNavFor: slider2 ? slider2 : null,
    };

    const sliderSettings = {
        dots: false,
        vertical: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: 'slider-main',
        asNavFor: slider1 ? slider1 : null,
        beforeChange: (current, next) => {
            setOldSlide(current);
            setActiveSlide(next);
        },
        afterChange: current => setActiveSlide2(current)
    };


    //DONE: handle params from url (when present) - we need to preselect step1 and move to step2
    useEffect(() => {
        async function runCheck() {




            const queryParameters = new URLSearchParams(window.location.search)

            let year = window.sessionStorage.getItem("user_year") ?? currentAppData?.year
            let make = window.sessionStorage.getItem("user_make") ?? currentAppData?.make
            let model = window.sessionStorage.getItem("user_model") ?? currentAppData?.model
            let trim = window.sessionStorage.getItem("user_trim") ?? currentAppData?.trim

            if (queryParameters.get("user_year")) {
                year = queryParameters.get("user_year") ?? currentAppData?.year
                make = queryParameters.get("user_make") ?? currentAppData?.make
                model = queryParameters.get("user_model") ?? currentAppData?.model
                trim = queryParameters.get("trim") ?? undefined
            }

            if (queryParameters.get("year")) {
                year = queryParameters.get("year") ?? currentAppData?.year
                make = queryParameters.get("make") ?? currentAppData?.make
                model = queryParameters.get("model") ?? currentAppData?.model
                trim = queryParameters.get("trim") ?? undefined
            }

            let newStep = 1;

            if (year && make && model && year !== '' && make !== '' && model !== '') {

                newStep = 2;

                // console.log('year make model preset: ', year, make, model);
                setCurrentAppData(prevState => {
                    return {
                        ...prevState,
                        year: year,
                        make: make,
                        model: model,
                        step: newStep,
                        color: "Black",
                    }
                })
            }
        }

        runCheck();
    }, []);

    useEffect(() => {
        if (slider2 && currentAppData.color && typeof slider2.slickGoTo !== 'undefined')
            slider2.slickGoTo(0);
    }, [currentAppData.color]);

    useEffect(() => {
        if (currentAppData.originalProduct) {
            setProduct(currentAppData.originalProduct);
        }
    }, [currentAppData.originalProduct]);



    //DONE: when selecting color show only the images and thumbs for that color
    //DONE: move arrows for vertical slider top and bottom of slider
    //DONE: move arrows of main slider to be over the image

    //DONE: optimize images

    const options = {
        pinchToClose: true,
        closeOnVerticalDrag: true,
        escKey: true,
        clickToCloseNonZoomable: true,
    }

    const getBonusTitleProps = function () {
        if (window.scs_show_new_year_promo_section) {
            return {
                title: '🎁 2 FREE GIFTS WITH PURCHASE',
                subtitle: 'Select Year Make Model To Begin'
            }
        }
        if (window.scs_show_bf_section) {
            return {
                title: window.scs_intro_text_1,
                subtitle: window.scs_intro_text_2
            }
        }
        if (window.scs_show_earlybf_section) {
            return {
                title: '🎁 2 FREE GIFTS WITH YOUR ORDER',
                subtitle: 'Select Year Make Model To Begin'
            }
        }
        return {
            title: '🎁 FREE GIFTS WITH YOUR ORDER',
            subtitle: 'Select Year Make Model To Begin'
        }
    }

    let hideBonusSection = (window.is_real_truck || window.scs_force_custom || window.scs_show_bonus_section);

    if (window.scs_show_str_section) {
        hideBonusSection = false;
    }

    function renderElem(el, product) {
        switch (el.type) {
            case "title":
                return (<h1>{product.title}</h1>);
            case "countdown":
                return ((window.scs_show_timer) ? (<Countdown date={new Date(window.scs_countdown_timer).getTime()} />): '');
            case "status_bar":
                return (<StatusBar/>);
            case "step1":
                return (<Step1/>);
            case "next_steps":
                return (<>
                    <MainStep/>
                </>);
            case "title_reviews":
                return (window.is_real_truck ? '' : (
                    <div className={`${styles.product_review}`}>
                        <div className={`${styles.product_stars}`}>
                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"/>
                            </svg>

                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"/>
                            </svg>

                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"/>
                            </svg>

                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"/>
                            </svg>

                            <svg width="17" height="15" viewBox="0 0 17 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.4658 12.5664L4.65918 14.8595C4.49102 14.9666 4.31521 15.0124 4.13176 14.9971C3.94831 14.9818 3.78779 14.9207 3.6502 14.8137C3.51261 14.7067 3.4056 14.5728 3.32916 14.4119C3.25272 14.2511 3.23744 14.0716 3.2833 13.8735L4.29228 9.53946L0.921365 6.62717C0.768489 6.48959 0.673095 6.33273 0.635181 6.15662C0.597268 5.98051 0.608581 5.80868 0.66912 5.64112C0.73027 5.47296 0.821996 5.33537 0.944297 5.22836C1.0666 5.12135 1.23476 5.05255 1.44879 5.02198L5.89748 4.63214L7.61733 0.550354C7.69377 0.366903 7.8124 0.229314 7.97323 0.137588C8.13405 0.0458629 8.29824 0 8.4658 0C8.63396 0 8.79815 0.0458629 8.95836 0.137588C9.11858 0.229314 9.23721 0.366903 9.31426 0.550354L11.0341 4.63214L15.4828 5.02198C15.6968 5.05255 15.865 5.12135 15.9873 5.22836C16.1096 5.33537 16.2013 5.47296 16.2625 5.64112C16.3236 5.80929 16.3352 5.98143 16.2973 6.15754C16.2594 6.33365 16.1637 6.4902 16.0102 6.62717L12.6393 9.53946L13.6483 13.8735C13.6942 14.0722 13.6789 14.252 13.6024 14.4128C13.526 14.5737 13.419 14.7073 13.2814 14.8137C13.1438 14.9207 12.9833 14.9818 12.7998 14.9971C12.6164 15.0124 12.4406 14.9666 12.2724 14.8595L8.4658 12.5664Z"
                                    fill="#FFD201"/>
                            </svg>

                        </div>
                        <span className={`${styles.review_text}`}>4.95/5 By Thousands of Happy Drivers</span>
                    </div>));
            default:
                return (<RawHtml html={el.content} />);
        }
    }

    return (
        <>
            {status === 'loading' ? (
                <p>Loading...</p>
            ) : status === 'error' ? (
                <span>Error: {error.message}</span>
            ) : (
                product ? (<section className={`${styles.section__product} ${window.scs_custom_style ? generalStyles.style01 : ''}`}>
                    <div className={`${styles.section__product_left}`}>
                        <div className={`${styles.product_images}`}>
                            <div className={`${styles.product_thumbs}`}>
                                {product?.images?.edges ?
                                    (<Slider
                                        ref={(slider) => setSlider1(slider)}
                                        {...thumbSettings}>
                                        {product?.images?.edges
                                            .filter((image) => image.node
                                                && image.node.altText
                                                && currentAppData.color
                                                && (image.node.altText.toLowerCase().endsWith(' - ' + currentAppData.color.toLowerCase())
                                                    || image.node.altText.toLowerCase().endsWith(' - all'))
                                            )
                                            .map((image) => {
                                                return (<div key={`thumb-${image.node.id}`}>
                                                    <img src={getImageUrl(image.node.url, 100, 100)}
                                                         alt={image.node.altText}
                                                         className={`${styles.thumb_image}`}/>
                                                </div>);
                                            })}
                                    </Slider>) : ''}
                            </div>
                            <div className={`${styles.product_main_image}`}>
                                {product?.images?.edges ?
                                    (<Gallery id="my-gallery">
                                        <Slider
                                            ref={(slider) => setSlider2(slider)}
                                            {...sliderSettings}>
                                            {product?.images?.edges
                                                .filter((image) => image.node
                                                    && image.node.altText
                                                    && currentAppData.color
                                                    && (image.node.altText.toLowerCase().endsWith(' - ' + currentAppData.color.toLowerCase())
                                                        || image.node.altText.toLowerCase().endsWith(' - all'))
                                                )
                                                .map((image) => {
                                                    return (
                                                        <Item
                                                            original={getImageUrl(image.node.url, 2000, undefined)}
                                                            thumbnail={getImageUrl(image.node.url, 600, undefined)}
                                                            width="2000"
                                                            height="2000"
                                                        >
                                                            {({ref, open}) =>
                                                                (<div key={`image-${image.node.id}`} data-id={image.node.id} className={`${image.node.video_url?styles.slide_video:''}`}>
                                                                    {image.node.video_url ?
                                                                        (<video width="100%" loop={true}  preload="auto" autoPlay playsInline muted={true} webkit-playsinline={true} controls={false} webkit-playsinline>
                                                                            <source src={image.node.video_url} type={image.node.video_type} />
                                                                            Your browser does not support the video tag.
                                                                        </video>) :
                                                                        (<img ref={ref} onClick={open} src={getImageUrl(image.node.url, 600, undefined)}
                                                                              alt={image.node.altText}
                                                                              className={`${styles.main_image}`}/>)}

                                                                </div>)}
                                                        </Item>
                                                    )
                                                        ;
                                                })}
                                        </Slider></Gallery>) : ''}

                            </div>
                        </div>
                    </div>

                    <div className={`${styles.section__product_right}`}>

                        {window.scs_blocks && window.scs_blocks.length > 0 && window.scs_blocks.map((el) => {
                            return renderElem(el, product);
                        })}

                    </div>

                </section>) : (<></>)
            )}
            <div>
                {isFetching ? 'Background Updating...' : null}
            </div>

        </>
    );
};

export default Product;